// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import DeletePopup from "~/photo/components/delete-popup";
import Exif from "~/photo/components/exif";
import { store } from "~/photo/globals";
import MyMapsPopup from "~/es6/mymaps.popup";
import { icon, node } from "~/util/dom";

/**
 * kontextove menu v galerii u fotky
 */
const TYPES = [{
	type: "exif",
	icon: "camera",
	public: true,
	owner: true,
	onDetail: true,
	onList: false,
	onReview: true,
	fc: data => {
		let exifPopup = new Exif(event => {
			if (event == "close") {
				exifPopup.close();
				exifPopup.destroy();
			}
		});
		exifPopup.open(data);

		let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
		let logData = {
			galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
			section: "gallery",
			text: _("gallery.contextenu.exif"),
			place: "detail",
		};

		Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

		return () => {
			exifPopup.close();
			exifPopup.destroy();
		};
	},
},{
	type: "share",
	icon: "share",
	public: true,
	owner: true,
	onDetail: false,
	onList: true,
	onReview: true,
	approved: true,
	fc: data => {
		let shareData = {
			title: `${_("gallery.share.photo")}${data.title && data.title != "" ? ` - ${data.title}` : ``}`,
			type: "photo",
			myGallery: data.my,
			url: data.source !== "index" ? `${location.href}&sourcep=${data.source}&idp=${data.id}` : "",
			noFrame: true,
		};
		let sharePopup = new MyMapsShare(shareData, cbData => {
			sharePopup.destroy();
			sharePopup = null;
			Mapy.getComponent("photoDetail").activateKeyboard();
		});
		sharePopup.open();

		Mapy.getComponent("photoDetail").deactivateKeyboard();

		let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
		let logData = {
			text: _("gallery.contextenu.share"),
			galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
		};

		if (data.detail) {
			logData.place = "detail";
		}

		Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

		return () => {
			if (sharePopup) {
				sharePopup.destroy();
				sharePopup = null;
				Mapy.getComponent("photoDetail").activateKeyboard();
			}
		};
	},
},{
	type: "edit",
	icon: "edit",
	public: false,
	owner: true,
	onDetail: true,
	onList: true,
	onReview: false,
	fc: (data, options) => {
		let param = {
			poi: {
				id: data.id
			},
			data: [],
			editMode: true,
			source: data.my ? "mapy-my_maps" : "mapy-gallery",
			type: "poi",
			origin: "fotky",
		}

		let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
		let logData = {
			source: "mapy-my_maps-edit",
			origin: "fotky",
			text: _("gallery.contextenu.edit"),
			type: "poi",
		};

		if (data.detail) {
			logData.place = "detail";
		}

		Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

		const { user } = store.getState().user;

		if (user.state === "green") {
			Mapy.getComponent("imageUploader").activate().setData(param);
		} else {
			Mapy.getComponent("login").open({
				analyticsData: {
					loginOrigin: "photoUpload",
				},
				motivation: "photo",
			}).then(() => {
				Mapy.getComponent("imageUploader").activate().setData(param);
			}, e => {});
		}

		return () => {
			Mapy.getComponent("imageUploader").deactivate();
		}
	},
},{
	type: "delete",
	icon: "delete",
	public: false,
	owner: true,
	onDetail: true,
	onList: true,
	onReview: false,
	fc: (data, options) => {
		let deletePopup = new DeletePopup(event => {
			if (event.name === "open") {
				return;
			}

			if (event.name === "cancel" || event.name === "photo-delete") {
				deletePopup.close();
			}

			deletePopup.destroy();

			if (event.name === "photo-delete") {
				const e = new CustomEvent("photo-delete", {
					detail: {
						source: data.source,
						id: data.id,
					}
				});
				options.cont.dispatchEvent(e);
			}
		});


		deletePopup.open(data);

		let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
		let logData = {
			text: _("gallery.contextenu.delete"),
			section: "gallery",
			galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
		};

		if (data.detail) {
			logData.place = "detail";
		}

		Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));

		return () => {
			deletePopup.close();
			deletePopup.destroy();
		};
	},
},{
	type: "report",
	icon: "report",
	public: true,
	owner: false,
	onDetail: true,
	onList: true,
	onReview: true,
	fc: data => {
		const state = store.getState();
		const { user } = state.user;
		let loginPromise = Promise.resolve();

		if (user.state !== "green") {
			loginPromise = Mapy.getComponent("login").open({
				analyticsData: {
					loginOrigin: "photoReport",
					section: "gallery",
					...data.my ? {} : { publicProfile: "1" },
				},
				motivation: "report",
			});
		}

		loginPromise.then(() => {
			Mapy.BadPhoto.data = {
				id: data.id,
				source: data.source,
				url: data.url,
				coords: data.coords,
				poi: data.poi,

			};
			Mapy.BadPhoto.open(e => {
				if (e.name == "close") {
					Mapy.getComponent("photoDetail").activateKeyboard();
				}
			});

			Mapy.getComponent("photoDetail").deactivateKeyboard();

			let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
			let logData = {
				text: _("gallery.contextenu.report"),
				galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
				section: "gallery",
			};

			if (data.detail) {
				logData.place = "detail";
			}

			Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));
		}, () => {});

		return () => {
			Mapy.BadPhoto.close();
		};
	},
}];

export default class PhotoContextMenu {
	constructor() {
		this._node = node("div", { className: "photo-contextmenu" });
		this._items = [];
		this._list = node("ul");
		this._data = null;
		this._open = false;
		this._contentOpen = null;
	}

	destroy() {
		this.close();
	}

	get node() {
		return this._node;
	}

	get open() {
		return this._open;
	}

	set data(data) {
		this.close();

		this._data = data;

		const { user } = store.getState().user;
		this._build(user.state === "green" ? user.userPublicId : "");
	}

	close() {
		if (this._open) {
			while (this._items.length) {
				let i = this._items.shift();
				i.removeEventListener("click", this);
			}

			Mapy.Util.clear(this._list);
			Mapy.Util.clear(this._node);
			this._data = null;

			window.removeEventListener("click", this);

			this._open = false;
			this._contentOpen = null;

			return true;
		}
		else if (this._contentOpen) {
			this._contentOpen();
			this._contentOpen = null;
			return true;
		}

		return false;
	}

	handleEvent(event) {
		if (event.type == "click") {
			let type = event.currentTarget.dataset && event.currentTarget.dataset.type ? event.currentTarget.dataset.type : "";

			if (type != "") {
				for (let i = 0; i < TYPES.length; i++) {
					let t = TYPES[i];

					if (t.type == type) {
						this._contentOpen = t.fc(this._data, {
							cont: this._node,
							store,
						});

						break;
					}
				}
			}

			this.close();
			event.stopPropagation()
		}
	}

	_build(userPublicId) {
		TYPES.forEach(t => {
			let my = userPublicId && this._data.userPublicId == userPublicId;
			this._data.my = my;

			if ((t.public && !my) || (my && t.owner)) {
				if ((t.onDetail && this._data.detail) || (t.onList && !this._data.detail)) {
					const exif = t.type != "exif" || (t.type == "exif" && this._data.exif && this._data.exif.length);
					const approved = !t.approved || (t.approved && this._data.approved !== false);
					const editffoto = !(t.type === "edit" && this._data.source === "ffoto");
					const review = t.onReview || (!t.onReview && !this._data.review);

					if (exif && approved && editffoto && review) {
						let item = node("li", {}, _(`gallery.contextenu.${t.type}`));
						item.setAttribute("data-type", t.type);
						item.addEventListener("click", this);

						item.firstChild.before(icon(t.icon));

						this._items.push(item);

						this._list.appendChild(item);
					}
				}
			}
		});

		this._node.appendChild(this._list);

		window.addEventListener("click", this);

		this._open = true;
	}
}
